"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTag = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var react_bootstrap_1 = require("react-bootstrap");
exports.StyledTag = (0, styled_components_1.default)(react_bootstrap_1.Badge)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  background-color: ", " !important;\n  border: solid 0.5px ", ";\n  border-radius: ", ";\n  height: 1.4rem;\n  min-width: 4.5rem;\n  color: ", ";\n  font-weight: ", ";\n  text-transform: ", ";\n  margin-right: 0;\n  padding: 0.25em 0.4em;\n"], ["\n  ", "\n  background-color: ", " !important;\n  border: solid 0.5px ", ";\n  border-radius: ", ";\n  height: 1.4rem;\n  min-width: 4.5rem;\n  color: ", ";\n  font-weight: ", ";\n  text-transform: ", ";\n  margin-right: 0;\n  padding: 0.25em 0.4em;\n"])), function (_a) {
    var Utilities = _a.theme.Utilities;
    return Utilities.Flex.center('both');
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.Secondary.inactive;
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.Secondary.main;
}, function (_a) {
    var Dimensions = _a.theme.Dimensions;
    return Dimensions.Borders.Radiuses.medium;
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.primary;
}, function (_a) {
    var Typography = _a.theme.Typography;
    return Typography.Weights.normal;
}, function (_a) {
    var texttransformation = _a.texttransformation;
    return texttransformation;
});
var templateObject_1;
